export default "__VITE_ASSET__BJGCh99A__"